import React from "react";
import styled from "styled-components";

const StyledLabel = styled.label`
  font-weight: ${(props) => props.theme.fontWeights.bold};
  font-size: ${(props) => props.theme.fontSizes.xs}px;

  a {
    font-weight: ${(props) => props.theme.fontWeights.bold};
    text-decoration: underline;

    &,
    &:visited {
      color: ${(props) => props.theme.colors.text};
    }
  }
`;

interface Props {
  htmlFor?: string;
  children: React.ReactNode;
}

const Label: React.FC<Props> = ({ htmlFor, children, ...props }) => (
  <StyledLabel htmlFor={htmlFor} {...props}>
    {children}
  </StyledLabel>
);

export default Label;
